import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@vds-core/utilities';
import { Body } from '@vds-core/typography';
import { ColorTokens } from '@vds-tokens/color';
import { LayoutTokens } from '@vds-tokens/layout';

var _calculateHelperTextColor = function _calculateHelperTextColor(disabled, surface) {
  return disabled && surface !== 'dark' ? ColorTokens.interactive.disabled.onlight.value : disabled && surface === 'dark' ? ColorTokens.interactive.disabled.ondark.value : !disabled && surface === 'dark' ? ColorTokens.elements.secondary.ondark.value : ColorTokens.elements.secondary.onlight.value;
};

var propTypes = {
  /**
   * @ignore
   */
  calculateHelperTextColor: PropTypes.func
};
var defaultProps = {
  calculateHelperTextColor: _calculateHelperTextColor
};
var HelperTextWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "HelperTextWrapper",
  componentId: "VDS__sc-1iqvyak-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n"])), function (_ref) {
  var helperTextPlacement = _ref.helperTextPlacement;
  return helperTextPlacement === 'right' && "\n    position: relative;\n    width: 50%;\n    padding-top: 0px;\n    padding-left: ".concat(calculateRem(LayoutTokens.space['3X'].value), ";\n  ");
}, function (_ref2) {
  var helperTextPlacement = _ref2.helperTextPlacement;
  return helperTextPlacement === 'bottom' && "\n    padding-top: ".concat(calculateRem(LayoutTokens.space['2X'].value), ";\n  ");
});

var HelperText = function HelperText(props) {
  var helperText = props.helperText,
      helperTextPlacement = props.helperTextPlacement,
      disabled = props.disabled,
      surface = props.surface,
      calculateHelperTextColor = props.calculateHelperTextColor;
  return /*#__PURE__*/React.createElement(HelperTextWrapper, {
    "aria-hidden": "true",
    helperTextPlacement: helperTextPlacement
  }, /*#__PURE__*/React.createElement(Body, {
    size: "small",
    color: calculateHelperTextColor(disabled, surface)
  }, helperText));
};

HelperText.defaultProps = defaultProps;
HelperText.propTypes = propTypes;
export default HelperText;